"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniPDPPrice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const common_components_1 = require("@as-react/common-components");
const andes_react_1 = require("@yonderland/andes-react");
const usePriceProps_1 = require("../../../hooks/usePriceProps");
const MiniPDPPrice = ({ color, selectedSize, isOutOfStock }) => {
    const { feature_toggles: { lowest_price_all }, } = (0, common_components_1.useAemConfig)();
    const prices = (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.prices) || color.prices;
    const priceProps = (0, usePriceProps_1.usePriceProps)({
        priceInformation: {
            prices,
            hasDiscount: color.hasDiscount,
        },
        dynamicSavingsInformation: {
            productDiscountAmount: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productDiscountAmount) || color.price.productDiscountAmount,
            productDiscountPercentage: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productDiscountPercentage) || color.price.productDiscountPercentage,
        },
        enablePriceReference: lowest_price_all,
    });
    if (!priceProps) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginTop: 2 } }, opacity: isOutOfStock ? 0.5 : undefined, children: (0, jsx_runtime_1.jsx)(andes_react_1.Price, Object.assign({}, priceProps, { size: "lg" })) }));
};
exports.MiniPDPPrice = MiniPDPPrice;
